const bookingTypeBadge = (isPublic, isPrivate) => {
    if (isPublic) {
        return (
            <span className="badge rounded-pill px-2 py-1 d-inline-flex align-items-center gap-2 table-sb-active">
                <span className="dot-icon rounded-circle dot-icon-active" />
                Public
            </span>
        )
    }

    if (isPrivate) {
        return (
            <span className="badge rounded-pill px-2 py-1 d-inline-flex align-items-center gap-2 table-sb-high">
                <span className="dot-icon rounded-circle dot-icon-high" />
                Private
            </span>
        )
    }

    return <span className="text-muted">—</span>
}

export default bookingTypeBadge;